import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TTnaTemplateState } from './tna-templates.models';

export const getTnaTemplatesState = (state: TPlani8State) => state.tnaTemplateInfo;

export const GetTnaTemplateList = createSelector(
  getTnaTemplatesState,
  (state: TTnaTemplateState) => state.templateListingInfo,
);

export const GetUserPaginationOption = createSelector(
  getTnaTemplatesState,
  (state: TTnaTemplateState) => state.userPaginationOption,
);

export const GetTnaDefaultSteps = createSelector(
  getTnaTemplatesState,
  (state: TTnaTemplateState) => state.tnaDefaultSteps,
);

export const GetTnaDefaultStepsLoader = createSelector(
  getTnaTemplatesState,
  (state: TTnaTemplateState) => state.tnaDefaultStepsLoader,
);

export const GetTnaTemplateDetails = createSelector(
  getTnaTemplatesState,
  (state: TTnaTemplateState) => state.tnaTemplateDetails,
);
